/**
 * The phone menu button (below 1056px only): opens and closes the side nav
 * drawer. "Open menu" / "Close menu", with aria-expanded and aria-controls
 * pointing at the side nav.
 */
import { HeaderButton } from './HeaderButton'
import { IconClose, IconMenu } from './icons'
import type { PhoneMenuProps } from './types'

export function PhoneMenu({ open, onToggle, controls = 'side-nav' }: PhoneMenuProps) {
  return (
    <HeaderButton
      label={open ? 'Close menu' : 'Open menu'}
      icon={open ? <IconClose /> : <IconMenu />}
      aria-expanded={open}
      aria-controls={controls}
      onClick={onToggle}
      className="c-lg:hidden"
    />
  )
}

export default PhoneMenu
